import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const RedirectHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Lire le paramètre p dans l'URL
    const params = new URLSearchParams(location.search);
    const p = params.get('p');
    
    if (p === 'louise-trinit-ia') {
      // Rediriger vers la page Louise
      navigate('/louise-trinit-ia', { replace: true });
    }
  }, [location.search, navigate]);

  return null; // Ce composant ne rend rien
};

export default RedirectHandler;
